import React from 'react';

const Joyn2Loader = () => {
  return (
    <div className="joyn2-loader-container">
      <div className="joyn2-loader" />
    </div>
  );
};

export default Joyn2Loader;
